<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Studebook') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Studebook_section') }}</label>  
            <select id="studebookSectionId" v-model="localFormData.studebookSectionId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_studebook_section') }}</option>
                <option v-for="item in studebookSections" :key="item.id" :value="item.id">
                    {{ item.code }} ({{ item.description }}) {{ item.section }}
                </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Studebook_status') }}</label>  
            <select id="studebookStatusId" v-model="localFormData.studebookStatusId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_studebook_status') }}</option>
                <option v-for="item in studebookStatuses" :key="item.id" :value="item.id">
                    {{ item.code }} ({{ item.description }})
                </option>
            </select>
          </div>
        </div>
        <div class="col-4">          
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, watch } from 'vue'

  export default {
    name: "StudebookSection",
    props: {
      studebookSections: Array,
      studebookStatuses: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {

      const localFormData = reactive({ ...props.formData })
      
      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {        
          props.nextStep()
      }

      return {
        localFormData,
        validateAndNextStep
      }
    }    
};
</script>